// AUTO-GENERATED by scripts/generate-content-meta.ts — do not edit by hand.
// Source of truth: src/features/guides/content/<locale>/*.ts. Deliberately excludes
// blocks[] (the article body) — see registry.ts for why that stays a lazy per-file import.
import type { GuideMeta } from "@/features/guides/types";
import type { Locale } from "@/lib/i18n/config";

export const GUIDE_META: Partial<Record<Locale, Record<string, GuideMeta>>> = {
  "en": {
    "animals": {
      "id": "animals",
      "slug": "animals",
      "title": "Wild Animals Guide",
      "summary": "Wild animals: trough locations, favorite foods, weather bonuses, bond rewards, and animal-themed furniture unlocks.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-01-28",
      "readTimeMinutes": 6,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/animals-banner.webp",
      "bannerImage": "/guides/animals-banner.webp",
      "tags": [
        "animals",
        "wildlife",
        "beginner",
        "bonding"
      ],
      "relatedGuides": [
        "beginners-guide",
        "daily-checklist"
      ]
    },
    "beginner-birdwatching": {
      "id": "beginner-birdwatching",
      "slug": "birdwatching",
      "title": "Birdwatching in Heartopia: beginner guide",
      "summary": "Birdwatching beginner guide: unlock with Bailey J., use the Scanner, understand star ratings via poses, avoid invalid cards, and recycle Info Cards (daily limit) for rewards and materials.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-01-28",
      "readTimeMinutes": 7,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "bannerImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "guide",
        "beginner",
        "hobby",
        "birdwatching",
        "scanner",
        "info-cards",
        "recycling",
        "nest-of-hundreds"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking"
      ]
    },
    "beginner-cooking": {
      "id": "beginner-cooking",
      "slug": "cooking-basics",
      "title": "Cooking in Heartopia: beginner guide (unlock, recipes)",
      "summary": "Learn Cooking basics: unlock with Massimo, master the stove minigame, unlock recipes efficiently, and use beginner-friendly dishes for XP and early gold.",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "bannerImage": "/guides/cooking-banner.webp",
      "tags": [
        "guide",
        "cooking",
        "massimo",
        "recipes",
        "gold",
        "beginner",
        "hobby",
        "tickets"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "beginner-fishing-fast-xp": {
      "id": "beginner-fishing-fast-xp",
      "slug": "beginner-fishing-fast-xp",
      "title": "Fishing in Heartopia: fast leveling and completing the collection",
      "summary": "Short route, collection progress, and a simple setup (Mermaid Tail + attractors) to farm XP without wasting time on travel.",
      "category": "fishing",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "tags": [
        "fishing",
        "hobby",
        "xp",
        "collection",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "level-up-fishing"
      ]
    },
    "beginner-fishing": {
      "id": "beginner-fishing",
      "slug": "how-to-fish",
      "title": "Fishing in Heartopia: beginner guide (aiming, line tension, bait)",
      "summary": "Learn Fishing the right way: how to unlock with Vanya, how to aim, how to manage line tension, how to use bait, and how to level faster.",
      "category": "fishing",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-01-28",
      "readTimeMinutes": 7,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "hobby": "Fishing",
      "currency": "Gold",
      "tags": [
        "fishing",
        "hobby",
        "beginner",
        "bait",
        "vanya",
        "gold"
      ],
      "relatedGuides": [
        "unlock-hobbies",
        "upgrade-hobbies",
        "beginner-cooking"
      ]
    },
    "beginner-gardening": {
      "id": "beginner-gardening",
      "slug": "gardening",
      "title": "Gardening in Heartopia: a beginner's guide",
      "summary": "Learn Gardening basics in Heartopia: how to unlock with Blanc, how Plant Boxes work, how watering affects crop quality, how to remove weeds, when to use Fertilizer vs Growth Booster, and which early crops are easiest to rotate. Includes FAQ and links to crops, recipes, and flowers.",
      "category": "crafting",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "bannerImage": "/guides/gardening-banner.webp",
      "tags": [
        "heartopia",
        "gardening",
        "crops",
        "blanc",
        "flowers",
        "fertilizer",
        "gold",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-cooking"
      ]
    },
    "beginner-insect-catching": {
      "id": "beginner-insect-catching",
      "slug": "insect-catching",
      "title": "Insect Catching in Heartopia: beginner guide",
      "summary": "Learn how to unlock Insect Catching, use the Bubble Net properly, level up faster, farm rares with the Inflatable Insect Attractor, and clear Bait the Insects efficiently without draining all your stamina.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-blue-400 to-sky-500",
      "coverImage": "/guides/insect-banner.webp",
      "bannerImage": "/guides/insect-banner.webp",
      "tags": [
        "heartopia",
        "insects",
        "insect-catching",
        "beginner",
        "event",
        "bait-the-insects"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "beginners-guide": {
      "id": "beginners-guide",
      "slug": "beginner-guide",
      "title": "Heartopia Beginner Guide: quick start & hobbies",
      "summary": "The general guide for new players: character creation without fear, daily reset, currencies, resources, map, D.G. progression, hobby order, and links to detailed guides (Fishing, Gardening, Cooking, Insects, Birdwatching, Animals, Currencies, and Daily Checklist).",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 8,
      "color": "from-emerald-400 to-green-500",
      "coverImage": "/guides/generic-banner-3.webp",
      "tags": [
        "heartopia",
        "beginner",
        "guide",
        "daily",
        "currencies",
        "hobbies",
        "fishing",
        "gardening",
        "cooking",
        "insects",
        "birdwatching",
        "animals",
        "map"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking",
        "beginner-birdwatching",
        "beginner-insect-catching",
        "animals"
      ]
    },
    "birdwatching-fast-xp": {
      "id": "birdwatching-fast-xp",
      "slug": "birdwatching-fast-xp",
      "title": "Birdwatching: how to level faster (and stop taking bad photos)",
      "summary": "The hobby is slow by nature, so the secret is: short route + focus on new species + consistent shots (Perfect Photo helps a lot).",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "birdwatching",
        "hobby",
        "xp",
        "collection",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-birdwatching",
        "level-up-birdwatching"
      ]
    },
    "cat-care-fast-xp": {
      "id": "cat-care-fast-xp",
      "slug": "cat-care-fast-xp",
      "title": "Cat Care: how to level fast (daily routine + collection + co-op)",
      "summary": "Cat Care is the pet entry point: simple routine, easy to maintain, and great for steady daily progress.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "pets",
        "cat-care",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "dog-care-fast-xp"
      ]
    },
    "catch-insects-fast-xp": {
      "id": "catch-insects-fast-xp",
      "slug": "catch-insects-fast-xp",
      "title": "Catch Insects: how to level faster",
      "summary": "Insect catching is skill-based: smart repetition + focus on new species + events/swarms when they show up.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-blue-400 to-sky-500",
      "coverImage": "/guides/insect-banner.webp",
      "tags": [
        "insects",
        "catch-insects",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "beginner-insect-catching"
      ]
    },
    "cooking-fast-xp": {
      "id": "cooking-fast-xp",
      "slug": "cooking-fast-xp",
      "title": "Cooking: how to level fast (batch, easy recipes, and smart co-op)",
      "summary": "Cooking leveling is queue engineering: multiple recipes in parallel, low difficulty to repeat, and variety for certification/collection.",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "tags": [
        "cooking",
        "hobby",
        "xp",
        "recipes",
        "collection"
      ],
      "relatedGuides": [
        "beginner-cooking",
        "level-up-cooking"
      ]
    },
    "currencies": {
      "id": "currencies",
      "slug": "currencies",
      "title": "Currencies Guide",
      "summary": "Learn about all the currencies in Heartopia (free, premium, and event-only).",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-01-28",
      "readTimeMinutes": 6,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/generic-banner-3.webp",
      "relatedGuides": [
        "daily-checklist",
        "gold-early"
      ]
    },
    "daily-checklist": {
      "id": "daily-checklist",
      "slug": "daily-checklist",
      "title": "Daily Checklist Guide",
      "summary": "A practical daily checklist focused on resets, daily shops, and daily-limited actions.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 6,
      "color": "from-emerald-400 to-teal-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "daily",
        "checklist",
        "reset",
        "shops",
        "routine"
      ],
      "relatedGuides": [
        "gold-early",
        "beginner-cooking"
      ]
    },
    "dog-care-fast-xp": {
      "id": "dog-care-fast-xp",
      "slug": "dog-care-fast-xp",
      "title": "Dog Care: how to level fast (training + routine)",
      "summary": "Dog Care is usually more involved than Cat Care: training/walks are part of the deal. Plan your session and avoid doing everything scattered.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-indigo-400 to-blue-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "pets",
        "dog-care",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "cat-care-fast-xp"
      ]
    },
    "flowers": {
      "id": "flowers",
      "slug": "flower-crossbreeding",
      "title": "Heartopia Flower Crossbreeding",
      "summary": "How flower crossbreeding works in Heartopia — species, star level, and watering rules, plus shop info and community tips.",
      "category": "crafting",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-07-08",
      "readTimeMinutes": 7,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/guides/gardening-banner.webp",
      "tags": [
        "flowers",
        "crossbreeding",
        "gardening",
        "blanc"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "beginner-fishing",
        "gold-early"
      ]
    },
    "gardening-fast-xp": {
      "id": "gardening-fast-xp",
      "slug": "gardening-fast-xp",
      "title": "Gardening: level fast with crop rotation",
      "summary": "Short crops when you're online, long crops when you're away. XP comes from cadence — and from variety for the collection.",
      "category": "crafting",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 4,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "tags": [
        "gardening",
        "hobby",
        "xp",
        "crops",
        "collection"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "level-up-gardening"
      ]
    },
    "gold-early": {
      "id": "gold-early",
      "slug": "gold-early",
      "title": "Heartopia early-game gold guide (quests, fishing, cooking)",
      "summary": "Make gold fast early in Heartopia with a simple daily routine: daily requests, fishing into cooking profit, and two beginner routes (oyster mushrooms + black truffles). Includes minimaps, stove setups, and FAQ.",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/generic-banner.webp",
      "tags": [
        "heartopia",
        "gold",
        "money",
        "beginner",
        "early game",
        "daily requests",
        "daily quests",
        "fishing",
        "cooking",
        "mushrooms",
        "oyster mushroom",
        "black truffle",
        "route",
        "map",
        "albert jr",
        "dg membership",
        "vip"
      ],
      "relatedGuides": [
        "daily-checklist",
        "beginner-cooking",
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "level-up-birdwatching": {
      "id": "level-up-birdwatching",
      "slug": "level-up-birdwatching",
      "title": "Fast Birdwatching Leveling (without pain) in Heartopia",
      "summary": "Birdwatching is one of the slowest hobbies to level — until you run the right loop: better photos, collection progress, and species rotation.",
      "category": "exploration",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "Birdwatching",
        "Hobbies",
        "Leveling",
        "XP",
        "Collection",
        "Photos"
      ],
      "relatedGuides": [
        "beginner-birdwatching",
        "upgrade-hobbies"
      ]
    },
    "level-up-cooking": {
      "id": "level-up-cooking",
      "slug": "level-up-cooking",
      "title": "Heartopia Cooking: fastest way to level (XP)",
      "summary": "Cooking leveling is volume + consistency: batch easy recipes, unlock variants for extra XP, and rotate to avoid ingredient bottlenecks (including daily purchase caps). Practical route + checklist.",
      "category": "cooking",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "bannerImage": "/guides/cooking-banner.webp",
      "hobby": "Cooking",
      "tags": [
        "cooking",
        "recipes",
        "xp",
        "leveling",
        "massimo"
      ],
      "relatedGuides": [
        "beginner-cooking",
        "cooking-fast-xp"
      ]
    },
    "level-up-fishing": {
      "id": "level-up-fishing",
      "slug": "level-up-fishing",
      "title": "Fast Fishing Leveling in Heartopia (route + buffs + checklist)",
      "summary": "A practical Fishing guide: spot rotation, collection XP, and the easy setup with Mermaid Fish Attractor + Mermaid Perfume.",
      "category": "fishing",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "hobby": "Fishing",
      "tags": [
        "fishing",
        "hobbies",
        "leveling",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-fishing-fast-xp"
      ]
    },
    "level-up-gardening": {
      "id": "level-up-gardening",
      "slug": "level-up-gardening",
      "title": "Heartopia Gardening: fastest leveling (XP/hour)",
      "summary": "Leveling Gardening is about harvest cycles. Go short crops when active (more harvests/hour) and long crops when AFK. Here's a practical rotation with boosters and a checklist.",
      "category": "crafting",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "bannerImage": "/guides/gardening-banner.webp",
      "hobby": "Gardening",
      "tags": [
        "gardening",
        "farming",
        "crops",
        "xp",
        "leveling"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "gardening-fast-xp"
      ]
    },
    "mlp-collab-guide": {
      "id": "mlp-collab-guide",
      "slug": "mlp-collab-guide",
      "title": "Heartopia x My Little Pony Event Guide",
      "summary": "Complete guide for the Heartopia x My Little Pony collab: Rainbow Power draws (cars + full sets), collect-all reward car, and the daily Harmony Tree Awakening with souvenir badges.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-14",
      "readTimeMinutes": 8,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/events/mlp/mlp-banner.webp",
      "bannerImage": "/events/mlp/mlp-banner.webp",
      "tags": [
        "heartopia",
        "my little pony",
        "mlp",
        "event",
        "rainbow power",
        "gacha",
        "cars",
        "harmony tree",
        "souvenir badges"
      ],
      "relatedGuides": [
        "currencies",
        "daily-checklist",
        "gold-early"
      ]
    },
    "unlock-hobbies": {
      "id": "unlock-hobbies",
      "slug": "unlock-hobbies",
      "title": "Unlock Hobbies in Heartopia (Tickets, Mentors, D.G. Levels)",
      "summary": "How to unlock every hobby in Heartopia: Hobby Expansion Tickets, D.G. (Developer) levels, mentors, unlock order, and what to do when you're stuck waiting on tickets.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-09",
      "readTimeMinutes": 6,
      "color": "from-violet-400 to-purple-500",
      "coverImage": "/guides/generic-banner.webp",
      "tags": [
        "guide",
        "beginner",
        "hobbies",
        "unlock",
        "hobby expansion ticket",
        "dg member",
        "developer level",
        "mentors"
      ],
      "relatedGuides": [
        "upgrade-hobbies",
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking"
      ]
    },
    "upgrade-hobbies": {
      "id": "upgrade-hobbies",
      "slug": "upgrade-hobbies",
      "title": "Upgrade Hobbies in Heartopia (Meter, Tickets, Skills & Tools)",
      "summary": "How to upgrade hobbies in Heartopia: filling the hobby meter, spending Hobby Upgrade Tickets, where tickets come from, and what upgrades typically unlock (skills, tools, better quality).",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-09",
      "readTimeMinutes": 6,
      "color": "from-indigo-400 to-violet-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "guide",
        "beginner",
        "hobbies",
        "upgrade",
        "hobby upgrade ticket",
        "skills",
        "tools",
        "meter",
        "dg member"
      ],
      "relatedGuides": [
        "unlock-hobbies",
        "beginner-birdwatching",
        "beginner-cooking",
        "gold-early"
      ]
    }
  },
  "pt-BR": {
    "animals": {
      "id": "animals",
      "slug": "animals",
      "title": "Guia de Animais Selvagens",
      "summary": "Animais selvagens: locais dos cochos, comidas favoritas, bônus por clima, recompensas de vínculo e móveis temáticos.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia Guide",
      "date": "2026-01-28",
      "readTimeMinutes": 6,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/animals-banner.webp",
      "bannerImage": "/guides/animals-banner.webp",
      "tags": [
        "animals",
        "wildlife",
        "beginner",
        "bonding"
      ],
      "relatedGuides": [
        "beginners-guide",
        "daily-checklist"
      ]
    },
    "beginner-birdwatching": {
      "id": "beginner-birdwatching",
      "slug": "birdwatching",
      "title": "Birdwatching no Heartopia: guia iniciante",
      "summary": "Guia iniciante de observação de aves: desbloqueie com Bailey J., use o Scanner, entenda as estrelas por poses/ações, evite cards inválidos e recicle Cartões de Info (limite diário) por recompensas e materiais.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-01-28",
      "readTimeMinutes": 7,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "bannerImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "guide",
        "beginner",
        "hobby",
        "birdwatching",
        "scanner",
        "info-cards",
        "recycling",
        "nest-of-hundreds"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking"
      ]
    },
    "beginner-cooking": {
      "id": "beginner-cooking",
      "slug": "cooking-basics",
      "title": "Cooking no Heartopia: guia iniciante (desbloqueio, receitas)",
      "summary": "Aprenda o básico de Cooking: como desbloquear com Massimo, dominar o minigame do fogão, liberar receitas com eficiência e usar pratos simples para XP e gold no começo do jogo.",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "bannerImage": "/guides/cooking-banner.webp",
      "tags": [
        "guide",
        "cooking",
        "massimo",
        "recipes",
        "gold",
        "beginner",
        "hobby",
        "tickets"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "beginner-fishing-fast-xp": {
      "id": "beginner-fishing-fast-xp",
      "slug": "beginner-fishing-fast-xp",
      "title": "Fishing no Heartopia: como upar rápido e completar a coleção",
      "summary": "Rota curta, coleção girando e um setup simples (Mermaid Tail + atratores) pra farmar XP sem perder tempo em viagem.",
      "category": "fishing",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "tags": [
        "fishing",
        "hobby",
        "xp",
        "collection",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "level-up-fishing"
      ]
    },
    "beginner-fishing": {
      "id": "beginner-fishing",
      "slug": "how-to-fish",
      "title": "Como pescar em Heartopia: guia de iniciante",
      "summary": "Aprenda a pescar em Heartopia do jeito certo: como desbloquear com Vanya, como mirar (PC e mobile), como controlar a tensão da linha (branco/amarelo/vermelho), como usar bait, e como upar mais rápido. Inclui FAQ e links para a lista completa de peixes.",
      "category": "fishing",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-01-28",
      "readTimeMinutes": 7,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "hobby": "Fishing",
      "currency": "Gold",
      "tags": [
        "fishing",
        "hobby",
        "beginner",
        "bait",
        "vanya",
        "gold"
      ],
      "relatedGuides": [
        "unlock-hobbies",
        "upgrade-hobbies",
        "beginner-cooking"
      ]
    },
    "beginner-gardening": {
      "id": "beginner-gardening",
      "slug": "gardening",
      "title": "Gardening em Heartopia: guia para iniciantes",
      "summary": "Aprenda o básico de Gardening em Heartopia: como desbloquear com Blanc, plantar em boxes, regar do jeito certo, tirar weeds, usar Fertilizante e Impulsionador de Crescimento, e quais crops valem mais no começo. Inclui FAQ e links para crops, recipes e flowers.",
      "category": "crafting",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "bannerImage": "/guides/gardening-banner.webp",
      "tags": [
        "heartopia",
        "gardening",
        "crops",
        "blanc",
        "flowers",
        "fertilizer",
        "gold",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-cooking"
      ]
    },
    "beginner-insect-catching": {
      "id": "beginner-insect-catching",
      "slug": "insect-catching",
      "title": "Como capturar insetos em Heartopia (guia de iniciante)",
      "summary": "Aprenda a desbloquear o hobby Insect Catching, usar a Rede de Insetos (Bubble Net) do jeito certo, upar mais rápido, farmar raros com o Atraidor de Insetos Inflável e aproveitar o evento Bait the Insects sem torrar sua stamina.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-blue-400 to-sky-500",
      "coverImage": "/guides/insect-banner.webp",
      "bannerImage": "/guides/insect-banner.webp",
      "tags": [
        "heartopia",
        "insects",
        "insect-catching",
        "beginner",
        "event",
        "bait-the-insects"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "beginners-guide": {
      "id": "beginners-guide",
      "slug": "beginner-guide",
      "title": "Guia de Iniciante em Heartopia: começo rápido e hobbies",
      "summary": "O guia geral para novos players: criação do personagem sem medo, reset diário, moedas, recursos, mapa, progressão do D.G., ordem dos hobbies e links para guias detalhados (Fishing, Gardening, Cooking, Insects, Birdwatching, Animals, Currencies e Daily Checklist).",
      "category": "beginner",
      "difficulty": "easy",
      "author": "heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 8,
      "color": "from-emerald-400 to-green-500",
      "coverImage": "/guides/generic-banner-3.webp",
      "tags": [
        "heartopia",
        "beginner",
        "guide",
        "daily",
        "currencies",
        "hobbies",
        "fishing",
        "gardening",
        "cooking",
        "insects",
        "birdwatching",
        "animals",
        "map"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking",
        "beginner-birdwatching",
        "beginner-insect-catching",
        "animals"
      ]
    },
    "birdwatching-fast-xp": {
      "id": "birdwatching-fast-xp",
      "slug": "birdwatching-fast-xp",
      "title": "Birdwatching: como upar mais rápido (e parar de tirar foto ruim)",
      "summary": "O hobby é lento por natureza, então o segredo é: rota curta + foco em espécie nova + consistência nas fotos (Perfect Photo ajuda muito).",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "birdwatching",
        "hobby",
        "xp",
        "collection",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-birdwatching",
        "level-up-birdwatching"
      ]
    },
    "cat-care-fast-xp": {
      "id": "cat-care-fast-xp",
      "slug": "cat-care-fast-xp",
      "title": "Cat Care: como upar rápido (rotina diária + coleção + co-op)",
      "summary": "Cat Care é o ponto de entrada de pets: rotina simples, fácil de manter, e excelente pra progresso diário constante.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "pets",
        "cat-care",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "dog-care-fast-xp"
      ]
    },
    "catch-insects-fast-xp": {
      "id": "catch-insects-fast-xp",
      "slug": "catch-insects-fast-xp",
      "title": "Catch Insects: como upar mais rápido",
      "summary": "Insect catching é skill-based: repetição inteligente + foco em espécie nova + eventos/swarms quando aparecerem.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-blue-400 to-sky-500",
      "coverImage": "/guides/insect-banner.webp",
      "tags": [
        "insects",
        "catch-insects",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "beginner-insect-catching"
      ]
    },
    "cooking-fast-xp": {
      "id": "cooking-fast-xp",
      "slug": "cooking-fast-xp",
      "title": "Cooking: como upar rápido (batch + receitas fáceis)",
      "summary": "Upar Cooking é engenharia de fila: várias receitas em paralelo, dificuldade baixa pra repetir, e variedade pra certificação/coleção.",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "tags": [
        "cooking",
        "hobby",
        "xp",
        "recipes",
        "collection"
      ],
      "relatedGuides": [
        "beginner-cooking",
        "level-up-cooking"
      ]
    },
    "currencies": {
      "id": "currencies",
      "slug": "currencies",
      "title": "Guia de Moedas (Currencies)",
      "summary": "Aprenda todas as moedas (currencies) de Heartopia e para que cada uma serve.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia Guide",
      "date": "2026-01-28",
      "readTimeMinutes": 6,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/generic-banner-3.webp",
      "relatedGuides": [
        "daily-checklist",
        "gold-early"
      ]
    },
    "daily-checklist": {
      "id": "daily-checklist",
      "slug": "daily-checklist",
      "title": "Checklist Diário (Guia)",
      "summary": "Checklist diário prático: reset do servidor, limites diários e lojas com rotação.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia Guide",
      "date": "2026-02-03",
      "readTimeMinutes": 6,
      "color": "from-emerald-400 to-teal-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "daily",
        "checklist",
        "reset",
        "shops",
        "routine"
      ],
      "relatedGuides": [
        "gold-early",
        "beginner-cooking"
      ]
    },
    "dog-care-fast-xp": {
      "id": "dog-care-fast-xp",
      "slug": "dog-care-fast-xp",
      "title": "Dog Care: como upar rápido (treino + rotina)",
      "summary": "Dog Care costuma ser mais trabalhoso que Cat Care: treino/passeio entram na conta. Planeje a sessão e evite fazer tudo espalhado.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-indigo-400 to-blue-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "pets",
        "dog-care",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "cat-care-fast-xp"
      ]
    },
    "flowers": {
      "id": "flowers",
      "slug": "flower-crossbreeding",
      "title": "Cruzamento de Flores no Heartopia",
      "summary": "Como funciona o cruzamento de flores no Heartopia — espécie, nível de estrelas e regras de rega, além de informações de loja e dicas da comunidade.",
      "category": "crafting",
      "difficulty": "medium",
      "author": "Heartopia Hub",
      "date": "2026-07-08",
      "readTimeMinutes": 7,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/guides/gardening-banner.webp",
      "tags": [
        "flowers",
        "crossbreeding",
        "gardening",
        "blanc"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "beginner-fishing",
        "gold-early"
      ]
    },
    "gardening-fast-xp": {
      "id": "gardening-fast-xp",
      "slug": "gardening-fast-xp",
      "title": "Gardening: upar rápido com rotação de crops",
      "summary": "Crops rápidas quando você está online, crops longas quando vai sair. O XP vem da cadência — e da variedade pra coleção.",
      "category": "crafting",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 4,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "tags": [
        "gardening",
        "hobby",
        "xp",
        "crops",
        "collection"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "level-up-gardening"
      ]
    },
    "gold-early": {
      "id": "gold-early",
      "slug": "gold-early",
      "title": "Guia de gold no early game de Heartopia (missões, pesca, cooking)",
      "summary": "Faça gold rápido no começo de Heartopia com uma rotina diária simples: Daily Requests, pesca virando lucro em Cooking e duas rotas para iniciantes (Oyster Mushrooms + Black Truffles). Inclui minimapas, setups de fogão e FAQ.",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia Guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/generic-banner.webp",
      "tags": [
        "heartopia",
        "gold",
        "money",
        "beginner",
        "early game",
        "daily requests",
        "daily quests",
        "fishing",
        "cooking",
        "mushrooms",
        "oyster mushroom",
        "black truffle",
        "route",
        "map",
        "albert jr",
        "dg membership",
        "vip"
      ],
      "relatedGuides": [
        "daily-checklist",
        "beginner-cooking",
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "level-up-birdwatching": {
      "id": "level-up-birdwatching",
      "slug": "level-up-birdwatching",
      "title": "Como upar Birdwatching rápido (sem sofrer) no Heartopia",
      "summary": "Birdwatching é um dos hobbies mais chatos de upar — até você usar o loop certo: fotos melhores, coleção avançando e rotação de espécies.",
      "category": "exploration",
      "difficulty": "medium",
      "author": "Heartopia Guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "Birdwatching",
        "Hobbies",
        "Leveling",
        "XP",
        "Collection",
        "Photos"
      ],
      "relatedGuides": [
        "beginner-birdwatching",
        "upgrade-hobbies"
      ]
    },
    "level-up-cooking": {
      "id": "level-up-cooking",
      "slug": "level-up-cooking",
      "title": "Cooking em Heartopia: como upar rápido (XP)",
      "summary": "Upar Cooking é volume + consistência: faça receitas fáceis em lote, desbloqueie variantes para XP extra e evite gargalos (como limite diário de ingredientes). Guia com rota prática e checklist.",
      "category": "cooking",
      "difficulty": "medium",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "bannerImage": "/guides/cooking-banner.webp",
      "hobby": "Cooking",
      "tags": [
        "cooking",
        "recipes",
        "xp",
        "leveling",
        "massimo"
      ],
      "relatedGuides": [
        "beginner-cooking",
        "cooking-fast-xp"
      ]
    },
    "level-up-fishing": {
      "id": "level-up-fishing",
      "slug": "level-up-fishing",
      "title": "Como upar Fishing rápido no Heartopia (rota + buffs + checklist)",
      "summary": "Guia prático de Fishing: rotação de locais, como farmar XP pela coleção, e o setup fácil com Mermaid Tail + Perfume de Sereia.",
      "category": "fishing",
      "difficulty": "medium",
      "author": "Heartopia Guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "hobby": "Fishing",
      "tags": [
        "fishing",
        "hobbies",
        "leveling",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-fishing-fast-xp"
      ]
    },
    "level-up-gardening": {
      "id": "level-up-gardening",
      "slug": "level-up-gardening",
      "title": "Gardening no Heartopia: como upar rápido (XP/h)",
      "summary": "O jeito eficiente de upar Gardening é simples: maximize colheitas por hora quando estiver ativo, e use crops longas quando estiver AFK. Aqui vai uma rota prática com rotação de crops, boosters e checklist.",
      "category": "crafting",
      "difficulty": "medium",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "bannerImage": "/guides/gardening-banner.webp",
      "hobby": "Gardening",
      "tags": [
        "gardening",
        "farming",
        "crops",
        "xp",
        "leveling"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "gardening-fast-xp"
      ]
    },
    "mlp-collab-guide": {
      "id": "mlp-collab-guide",
      "slug": "mlp-collab-guide",
      "title": "Guia do Evento Heartopia x My Little Pony",
      "summary": "Guia completo do collab Heartopia x My Little Pony: sorteios Rainbow Power (carros + sets), carro especial por coletar todos, e rotina diária do Harmony Tree Awakening com badges de souvenir.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia Guide",
      "date": "2026-02-14",
      "readTimeMinutes": 8,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/events/mlp/mlp-banner.webp",
      "bannerImage": "/events/mlp/mlp-banner.webp",
      "tags": [
        "heartopia",
        "my little pony",
        "mlp",
        "event",
        "rainbow power",
        "gacha",
        "cars",
        "harmony tree",
        "souvenir badges"
      ],
      "relatedGuides": [
        "currencies",
        "daily-checklist",
        "gold-early"
      ]
    },
    "unlock-hobbies": {
      "id": "unlock-hobbies",
      "slug": "unlock-hobbies",
      "title": "Desbloquear hobbies no Heartopia (Tickets, mentores, níveis D.G.)",
      "summary": "Como desbloquear todos os hobbies no Heartopia: Hobby Expansion Tickets, níveis D.G. (Developer), mentores, ordem de desbloqueio e o que fazer quando estiver preso esperando tickets.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-09",
      "readTimeMinutes": 6,
      "color": "from-violet-400 to-purple-500",
      "coverImage": "/guides/generic-banner.webp",
      "tags": [
        "guide",
        "beginner",
        "hobbies",
        "unlock",
        "hobby expansion ticket",
        "dg member",
        "developer level",
        "mentors"
      ],
      "relatedGuides": [
        "upgrade-hobbies",
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking"
      ]
    },
    "upgrade-hobbies": {
      "id": "upgrade-hobbies",
      "slug": "upgrade-hobbies",
      "title": "Upgrade de hobbies no Heartopia (Barra, tickets, skills)",
      "summary": "Como fazer upgrade dos hobbies no Heartopia: encher a barra do hobby, gastar Hobby Upgrade Tickets, de onde vêm os tickets e o que os upgrades costumam desbloquear (skills, ferramentas, melhor qualidade).",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-09",
      "readTimeMinutes": 6,
      "color": "from-indigo-400 to-violet-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "guide",
        "beginner",
        "hobbies",
        "upgrade",
        "hobby upgrade ticket",
        "skills",
        "tools",
        "meter",
        "dg member"
      ],
      "relatedGuides": [
        "unlock-hobbies",
        "beginner-birdwatching",
        "beginner-cooking",
        "gold-early"
      ]
    }
  },
  "es": {
    "animals": {
      "id": "animals",
      "slug": "animals",
      "title": "Guía de Animales Salvajes",
      "summary": "Animales salvajes: ubicaciones de comederos, comidas favoritas, bonos por clima, recompensas de vínculo y desbloqueos de muebles temáticos.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia Guide",
      "date": "2026-01-28",
      "readTimeMinutes": 6,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/animals-banner.webp",
      "bannerImage": "/guides/animals-banner.webp",
      "tags": [
        "animals",
        "wildlife",
        "beginner",
        "bonding"
      ],
      "relatedGuides": [
        "beginners-guide",
        "daily-checklist"
      ]
    },
    "beginner-birdwatching": {
      "id": "beginner-birdwatching",
      "slug": "birdwatching",
      "title": "Birdwatching en Heartopia: guía para principiantes",
      "summary": "Guía de Birdwatching para principiantes: desbloquéalo con Bailey J., usa el Scanner, entiende las estrellas por poses, evita invalid cards y recicla Info Cards para recompensas.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-01-28",
      "readTimeMinutes": 7,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "bannerImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "guide",
        "beginner",
        "hobby",
        "birdwatching",
        "scanner",
        "info-cards",
        "recycling",
        "nest-of-hundreds"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking"
      ]
    },
    "beginner-cooking": {
      "id": "beginner-cooking",
      "slug": "cooking-basics",
      "title": "Cooking en Heartopia: guía para principiantes",
      "summary": "Aprende Cooking desde la base: desbloquéalo con Massimo, domina el minijuego de la estufa y usa recetas simples para XP y gold temprano.",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "bannerImage": "/guides/cooking-banner.webp",
      "tags": [
        "guide",
        "cooking",
        "massimo",
        "recipes",
        "gold",
        "beginner",
        "hobby",
        "tickets"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "beginner-fishing-fast-xp": {
      "id": "beginner-fishing-fast-xp",
      "slug": "beginner-fishing-fast-xp",
      "title": "Fishing en Heartopia: subir rápido y completar la colección",
      "summary": "Ruta corta, progreso de colección y un setup simple con Mermaid Tail + attractors para farmear XP sin perder tiempo en desplazamientos.",
      "category": "fishing",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "tags": [
        "fishing",
        "hobby",
        "xp",
        "collection",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "level-up-fishing"
      ]
    },
    "beginner-fishing": {
      "id": "beginner-fishing",
      "slug": "how-to-fish",
      "title": "Fishing en Heartopia: guía para principiantes",
      "summary": "Aprende Fishing correctamente: cómo desbloquearlo con Vanya, cómo apuntar en PC y móvil, cómo manejar la tensión de línea y cómo usar bait para subir más rápido.",
      "category": "fishing",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-01-28",
      "readTimeMinutes": 7,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "hobby": "Fishing",
      "currency": "Gold",
      "tags": [
        "fishing",
        "hobby",
        "beginner",
        "bait",
        "vanya",
        "gold"
      ],
      "relatedGuides": [
        "unlock-hobbies",
        "upgrade-hobbies",
        "beginner-cooking"
      ]
    },
    "beginner-gardening": {
      "id": "beginner-gardening",
      "slug": "gardening",
      "title": "Gardening en Heartopia: guía de principiantes",
      "summary": "Aprende lo básico de Gardening en Heartopia: cómo desbloquearlo con Blanc, cómo funcionan los Plant Boxes, cómo regar afecta la calidad y cuándo usar Fertilizante o Potenciador de Crecimiento.",
      "category": "crafting",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "bannerImage": "/guides/gardening-banner.webp",
      "tags": [
        "heartopia",
        "gardening",
        "crops",
        "blanc",
        "flowers",
        "fertilizer",
        "gold",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-cooking"
      ]
    },
    "beginner-insect-catching": {
      "id": "beginner-insect-catching",
      "slug": "insect-catching",
      "title": "Insect Catching en Heartopia: guía para principiantes",
      "summary": "Aprende a desbloquear Insect Catching, usar bien la Bubble Net, subir más rápido y farmear rares con Atractor de Insectos Inflable.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-blue-400 to-sky-500",
      "coverImage": "/guides/insect-banner.webp",
      "bannerImage": "/guides/insect-banner.webp",
      "tags": [
        "heartopia",
        "insects",
        "insect-catching",
        "beginner",
        "event",
        "bait-the-insects"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "beginners-guide": {
      "id": "beginners-guide",
      "slug": "beginner-guide",
      "title": "Guía para Principiantes de Heartopia: inicio rápido",
      "summary": "La guía general para jugadores nuevos: creación de personaje sin miedo, reinicio diario, monedas, recursos, mapa, progreso D.G., orden de hobbies y enlaces a guías más detalladas.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 8,
      "color": "from-emerald-400 to-green-500",
      "coverImage": "/guides/generic-banner-3.webp",
      "tags": [
        "heartopia",
        "beginner",
        "guide",
        "daily",
        "currencies",
        "hobbies",
        "fishing",
        "gardening",
        "cooking",
        "insects",
        "birdwatching",
        "animals",
        "map"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking",
        "beginner-birdwatching",
        "beginner-insect-catching",
        "animals"
      ]
    },
    "birdwatching-fast-xp": {
      "id": "birdwatching-fast-xp",
      "slug": "birdwatching-fast-xp",
      "title": "Birdwatching: cómo subir rápido (y dejar de sacar malas fotos)",
      "summary": "Es un hobby lento por naturaleza, así que el secreto es: ruta corta, foco en especies nuevas y disparos consistentes.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "birdwatching",
        "hobby",
        "xp",
        "collection",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-birdwatching",
        "level-up-birdwatching"
      ]
    },
    "cat-care-fast-xp": {
      "id": "cat-care-fast-xp",
      "slug": "cat-care-fast-xp",
      "title": "Cat Care: cómo subir rápido (rutina diaria + colección + co-op)",
      "summary": "Cat Care es la puerta de entrada a pets: rutina simple, fácil de mantener y muy buena para progreso diario constante.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "pets",
        "cat-care",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "dog-care-fast-xp"
      ]
    },
    "catch-insects-fast-xp": {
      "id": "catch-insects-fast-xp",
      "slug": "catch-insects-fast-xp",
      "title": "Catch Insects: cómo subir más rápido",
      "summary": "Insect Catching depende de habilidad: repetición inteligente, foco en especies nuevas y aprovechar eventos o swarms cuando aparezcan.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-blue-400 to-sky-500",
      "coverImage": "/guides/insect-banner.webp",
      "tags": [
        "insects",
        "catch-insects",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "beginner-insect-catching"
      ]
    },
    "cooking-fast-xp": {
      "id": "cooking-fast-xp",
      "slug": "cooking-fast-xp",
      "title": "Cooking: cómo subir rápido (batch + recetas fáciles)",
      "summary": "El leveling de Cooking es ingeniería de cola: varias recetas en paralelo, baja dificultad para repetir y variedad para certificación y colección.",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "tags": [
        "cooking",
        "hobby",
        "xp",
        "recipes",
        "collection"
      ],
      "relatedGuides": [
        "beginner-cooking",
        "level-up-cooking"
      ]
    },
    "currencies": {
      "id": "currencies",
      "slug": "currencies",
      "title": "Guía de Monedas",
      "summary": "Aprende sobre todas las monedas de Heartopia: gratis, premium y de evento.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia Guide",
      "date": "2026-01-28",
      "readTimeMinutes": 6,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/generic-banner-3.webp",
      "relatedGuides": [
        "daily-checklist",
        "gold-early"
      ]
    },
    "daily-checklist": {
      "id": "daily-checklist",
      "slug": "daily-checklist",
      "title": "Guía de Checklist Diario",
      "summary": "Checklist diario práctico centrado en reinicios, tiendas diarias y acciones con límite diario.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia Guide",
      "date": "2026-02-03",
      "readTimeMinutes": 6,
      "color": "from-emerald-400 to-teal-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "daily",
        "checklist",
        "reset",
        "shops",
        "routine"
      ],
      "relatedGuides": [
        "gold-early",
        "beginner-cooking"
      ]
    },
    "dog-care-fast-xp": {
      "id": "dog-care-fast-xp",
      "slug": "dog-care-fast-xp",
      "title": "Dog Care: cómo subir rápido (training + rutina)",
      "summary": "Dog Care suele implicar más cosas que Cat Care: training y walks forman parte del loop. Organiza la sesión y evita hacerlo todo disperso.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-indigo-400 to-blue-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "pets",
        "dog-care",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "cat-care-fast-xp"
      ]
    },
    "flowers": {
      "id": "flowers",
      "slug": "flower-crossbreeding",
      "title": "Cruce de Flores en Heartopia",
      "summary": "Cómo funciona el cruce de flores en Heartopia — especie, nivel de estrellas y reglas de riego, más información de tienda y consejos de la comunidad.",
      "category": "crafting",
      "difficulty": "medium",
      "author": "Heartopia Hub",
      "date": "2026-07-08",
      "readTimeMinutes": 7,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/guides/gardening-banner.webp",
      "tags": [
        "flowers",
        "crossbreeding",
        "gardening",
        "blanc"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "beginner-fishing",
        "gold-early"
      ]
    },
    "gardening-fast-xp": {
      "id": "gardening-fast-xp",
      "slug": "gardening-fast-xp",
      "title": "Gardening: sube rápido con rotación de crops",
      "summary": "Crops cortos cuando estás online, crops largos cuando estás fuera. La XP viene de la cadencia y de la variedad.",
      "category": "crafting",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 4,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "tags": [
        "gardening",
        "hobby",
        "xp",
        "crops",
        "collection"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "level-up-gardening"
      ]
    },
    "gold-early": {
      "id": "gold-early",
      "slug": "gold-early",
      "title": "Guía de gold en early game de Heartopia (quests, pesca, cooking)",
      "summary": "Gana gold rápido al principio en Heartopia con una rutina simple: daily requests, pesca para cooking profit y dos rutas para principiantes.",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia Guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/generic-banner.webp",
      "tags": [
        "heartopia",
        "gold",
        "money",
        "beginner",
        "early game",
        "daily requests",
        "daily quests",
        "fishing",
        "cooking",
        "mushrooms",
        "oyster mushroom",
        "black truffle",
        "route",
        "map",
        "albert jr",
        "dg membership",
        "vip"
      ],
      "relatedGuides": [
        "daily-checklist",
        "beginner-cooking",
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "level-up-birdwatching": {
      "id": "level-up-birdwatching",
      "slug": "level-up-birdwatching",
      "title": "Subir Birdwatching rápido (sin sufrir) en Heartopia",
      "summary": "Birdwatching es uno de los hobbies más lentos hasta que usas el loop correcto: mejores fotos, progreso de colección y rotación de especies.",
      "category": "exploration",
      "difficulty": "medium",
      "author": "Heartopia Guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "Birdwatching",
        "Hobbies",
        "Leveling",
        "XP",
        "Collection",
        "Photos"
      ],
      "relatedGuides": [
        "beginner-birdwatching",
        "upgrade-hobbies"
      ]
    },
    "level-up-cooking": {
      "id": "level-up-cooking",
      "slug": "level-up-cooking",
      "title": "Heartopia Cooking: cómo subir de nivel rápido",
      "summary": "Subir Cooking va de volumen y constancia: haz recetas fáciles en batch, desbloquea variantes y rota ingredientes para evitar cuellos de botella.",
      "category": "cooking",
      "difficulty": "medium",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "bannerImage": "/guides/cooking-banner.webp",
      "hobby": "Cooking",
      "tags": [
        "cooking",
        "recipes",
        "xp",
        "leveling",
        "massimo"
      ],
      "relatedGuides": [
        "beginner-cooking",
        "cooking-fast-xp"
      ]
    },
    "level-up-fishing": {
      "id": "level-up-fishing",
      "slug": "level-up-fishing",
      "title": "Subir Fishing rápido en Heartopia (ruta + buffs + checklist)",
      "summary": "Guía práctica de Fishing: rotación de spots, XP de colección y setup simple con Mermaid Tail + Perfume de Sirena.",
      "category": "fishing",
      "difficulty": "medium",
      "author": "Heartopia Guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "hobby": "Fishing",
      "tags": [
        "fishing",
        "hobbies",
        "leveling",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-fishing-fast-xp"
      ]
    },
    "level-up-gardening": {
      "id": "level-up-gardening",
      "slug": "level-up-gardening",
      "title": "Heartopia Gardening: leveling más rápido (XP/hora)",
      "summary": "Subir Gardening va de ciclos de cosecha. Usa crops cortos si juegas activo y crops largos si vas AFK.",
      "category": "crafting",
      "difficulty": "medium",
      "author": "Heartopia Hub",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "bannerImage": "/guides/gardening-banner.webp",
      "hobby": "Gardening",
      "tags": [
        "gardening",
        "farming",
        "crops",
        "xp",
        "leveling"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "gardening-fast-xp"
      ]
    },
    "mlp-collab-guide": {
      "id": "mlp-collab-guide",
      "slug": "mlp-collab-guide",
      "title": "Guía del Evento Heartopia x My Little Pony",
      "summary": "Guía completa del collab Heartopia x My Little Pony: tiradas Rainbow Power, coche especial por coleccionarlo todo y rutina diaria del Harmony Tree Awakening con insignias souvenir.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia Guide",
      "date": "2026-02-14",
      "readTimeMinutes": 8,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/events/mlp/mlp-banner.webp",
      "bannerImage": "/events/mlp/mlp-banner.webp",
      "tags": [
        "heartopia",
        "my little pony",
        "mlp",
        "event",
        "rainbow power",
        "gacha",
        "cars",
        "harmony tree",
        "souvenir badges"
      ],
      "relatedGuides": [
        "currencies",
        "daily-checklist",
        "gold-early"
      ]
    },
    "unlock-hobbies": {
      "id": "unlock-hobbies",
      "slug": "unlock-hobbies",
      "title": "Desbloquear Hobbies en Heartopia (Tickets, Mentores)",
      "summary": "Cómo desbloquear todos los hobbies en Heartopia: Hobby Expansion Tickets, niveles D.G., mentores, orden de desbloqueo y qué hacer cuando te quedas esperando tickets.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-09",
      "readTimeMinutes": 6,
      "color": "from-violet-400 to-purple-500",
      "coverImage": "/guides/generic-banner.webp",
      "tags": [
        "guide",
        "beginner",
        "hobbies",
        "unlock",
        "hobby expansion ticket",
        "dg member",
        "developer level",
        "mentors"
      ],
      "relatedGuides": [
        "upgrade-hobbies",
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking"
      ]
    },
    "upgrade-hobbies": {
      "id": "upgrade-hobbies",
      "slug": "upgrade-hobbies",
      "title": "Mejorar Hobbies en Heartopia (Barra, Tickets, Skills y Tools)",
      "summary": "Cómo mejorar hobbies en Heartopia: llenar la barra del hobby, gastar Hobby Upgrade Tickets, de dónde salen y qué suelen desbloquear las mejoras.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia Hub",
      "date": "2026-02-09",
      "readTimeMinutes": 6,
      "color": "from-indigo-400 to-violet-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "guide",
        "beginner",
        "hobbies",
        "upgrade",
        "hobby upgrade ticket",
        "skills",
        "tools",
        "meter",
        "dg member"
      ],
      "relatedGuides": [
        "unlock-hobbies",
        "beginner-birdwatching",
        "beginner-cooking",
        "gold-early"
      ]
    }
  },
  "id": {
    "animals": {
      "id": "animals",
      "slug": "animals",
      "title": "Panduan Satwa Liar",
      "summary": "Satwa liar: lokasi tempat makan, makanan favorit, bonus cuaca, hadiah ikatan, dan buka furnitur tema hewan.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-01-28",
      "readTimeMinutes": 6,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/animals-banner.webp",
      "bannerImage": "/guides/animals-banner.webp",
      "tags": [
        "animals",
        "wildlife",
        "beginner",
        "bonding"
      ],
      "relatedGuides": [
        "beginners-guide",
        "daily-checklist"
      ]
    },
    "beginner-birdwatching": {
      "id": "beginner-birdwatching",
      "slug": "birdwatching",
      "title": "Pengamatan Burung di Heartopia: panduan pemula",
      "summary": "Panduan pemula Pengamatan Burung: buka dengan Bailey J., gunakan Scanner, pahami rating bintang via pose, hindari kartu tidak sah, dan daur ulang Info Card (batas harian) untuk hadiah dan material.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-01-28",
      "readTimeMinutes": 7,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "bannerImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "guide",
        "beginner",
        "hobby",
        "birdwatching",
        "scanner",
        "info-cards",
        "recycling",
        "nest-of-hundreds"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking"
      ]
    },
    "beginner-cooking": {
      "id": "beginner-cooking",
      "slug": "cooking-basics",
      "title": "Memasak di Heartopia: panduan pemula (buka, resep)",
      "summary": "Pelajari dasar Memasak: buka dengan Massimo, kuasai mini permainan kompor, buka resep efisien, dan gunakan hidangan ramah pemula untuk XP dan emas awal",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "bannerImage": "/guides/cooking-banner.webp",
      "tags": [
        "guide",
        "cooking",
        "massimo",
        "recipes",
        "gold",
        "beginner",
        "hobby",
        "tickets"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "beginner-fishing-fast-xp": {
      "id": "beginner-fishing-fast-xp",
      "slug": "beginner-fishing-fast-xp",
      "title": "Fishing di Heartopia: naik level cepat dan melengkapi koleksi",
      "summary": "Rute pendek, kemajuan koleksi, dan perlengkapan sederhana (Mermaid Tail + penarik ikan) untuk mengumpulkan XP tanpa membuang waktu di perjalanan.",
      "category": "fishing",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "tags": [
        "fishing",
        "hobby",
        "xp",
        "collection",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "level-up-fishing"
      ]
    },
    "beginner-fishing": {
      "id": "beginner-fishing",
      "slug": "how-to-fish",
      "title": "Fishing di Heartopia: panduan pemula (membidik, ketegangan tali, umpan)",
      "summary": "Pelajari Fishing dengan benar: cara membukanya bersama Vanya, cara membidik, cara mengelola ketegangan tali, cara memakai umpan, dan cara naik level lebih cepat.",
      "category": "fishing",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-01-28",
      "readTimeMinutes": 7,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "hobby": "Fishing",
      "currency": "Gold",
      "tags": [
        "fishing",
        "hobby",
        "beginner",
        "bait",
        "vanya",
        "gold"
      ],
      "relatedGuides": [
        "unlock-hobbies",
        "upgrade-hobbies",
        "beginner-cooking"
      ]
    },
    "beginner-gardening": {
      "id": "beginner-gardening",
      "slug": "gardening",
      "title": "Berkebun di Heartopia: panduan pemula",
      "summary": "Pelajari dasar Berkebun Heartopia: buka Blanc, cara Plant Boxes, penyiraman kualitas tanaman, hapus rumput, kapan Pupuk vs Booster Pertumbuhan, awal tanaman mudah putar. Ada FAQ & tautan tanaman, resep, bunga.",
      "category": "crafting",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "bannerImage": "/guides/gardening-banner.webp",
      "tags": [
        "heartopia",
        "gardening",
        "crops",
        "blanc",
        "flowers",
        "fertilizer",
        "gold",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-cooking"
      ]
    },
    "beginner-insect-catching": {
      "id": "beginner-insect-catching",
      "slug": "insect-catching",
      "title": "Menangkap Serangga di Heartopia: panduan pemula",
      "summary": "Pelajari buka Menangkap Serangga, gunakan Jaring Gelembung dengan benar, naik level lebih cepat, farm langka dengan Penarik Serangga yang Dapat Dikembangkan, dan hapus Umpan Serangga efisien tanpa habiskan semua stamina.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-blue-400 to-sky-500",
      "coverImage": "/guides/insect-banner.webp",
      "bannerImage": "/guides/insect-banner.webp",
      "tags": [
        "heartopia",
        "insects",
        "insect-catching",
        "beginner",
        "event",
        "bait-the-insects"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "beginners-guide": {
      "id": "beginners-guide",
      "slug": "beginner-guide",
      "title": "Panduan Pemula Heartopia: mulai cepat & hobi",
      "summary": "Panduan umum pemain baru: pembuatan karakter tanpa takut, reset harian, mata uang, sumber daya, peta, kemajuan D.G., urutan hobi, tautan panduan detail (Fishing, Gardening, Cooking, Serangga, Burung, Hewan, Mata Uang, Checklist Harian).",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 8,
      "color": "from-emerald-400 to-green-500",
      "coverImage": "/guides/generic-banner-3.webp",
      "tags": [
        "heartopia",
        "beginner",
        "guide",
        "daily",
        "currencies",
        "hobbies",
        "fishing",
        "gardening",
        "cooking",
        "insects",
        "birdwatching",
        "animals",
        "map"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking",
        "beginner-birdwatching",
        "beginner-insect-catching",
        "animals"
      ]
    },
    "birdwatching-fast-xp": {
      "id": "birdwatching-fast-xp",
      "slug": "birdwatching-fast-xp",
      "title": "Birdwatching: cara naik level lebih cepat (dan berhenti mengambil foto jelek)",
      "summary": "Hobi ini memang lambat dari sananya, jadi rahasianya: rute pendek + fokus pada spesies baru + bidikan yang konsisten (Perfect Photo sangat membantu).",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "birdwatching",
        "hobby",
        "xp",
        "collection",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-birdwatching",
        "level-up-birdwatching"
      ]
    },
    "cat-care-fast-xp": {
      "id": "cat-care-fast-xp",
      "slug": "cat-care-fast-xp",
      "title": "Cat Care: cara naik level cepat (rutinitas harian + koleksi + co-op)",
      "summary": "Cat Care adalah pintu masuk ke hewan peliharaan: rutinitasnya sederhana, gampang dijaga, dan bagus untuk kemajuan harian yang stabil.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "pets",
        "cat-care",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "dog-care-fast-xp"
      ]
    },
    "catch-insects-fast-xp": {
      "id": "catch-insects-fast-xp",
      "slug": "catch-insects-fast-xp",
      "title": "Bug Catching: cara naik level lebih cepat",
      "summary": "Menangkap serangga bergantung pada keterampilan: pengulangan yang cerdas + fokus pada spesies baru + memanfaatkan event dan kawanan saat muncul.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-blue-400 to-sky-500",
      "coverImage": "/guides/insect-banner.webp",
      "tags": [
        "insects",
        "catch-insects",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "beginner-insect-catching"
      ]
    },
    "cooking-fast-xp": {
      "id": "cooking-fast-xp",
      "slug": "cooking-fast-xp",
      "title": "Cooking: cara naik level cepat (batch, resep mudah, dan co-op yang cerdas)",
      "summary": "Menaikkan level Cooking itu soal mengatur antrean: banyak resep berjalan paralel, tingkat kesulitan rendah supaya bisa diulang, dan keragaman untuk sertifikasi serta koleksi.",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "tags": [
        "cooking",
        "hobby",
        "xp",
        "recipes",
        "collection"
      ],
      "relatedGuides": [
        "beginner-cooking",
        "level-up-cooking"
      ]
    },
    "currencies": {
      "id": "currencies",
      "slug": "currencies",
      "title": "Panduan Mata Uang",
      "summary": "Pelajari semua mata uang di Heartopia (gratis, premium, dan hanya acara).",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-01-28",
      "readTimeMinutes": 6,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/generic-banner-3.webp",
      "relatedGuides": [
        "daily-checklist",
        "gold-early"
      ]
    },
    "daily-checklist": {
      "id": "daily-checklist",
      "slug": "daily-checklist",
      "title": "Panduan Checklist Harian",
      "summary": "Checklist harian praktis fokus reset, toko harian, dan aksi batas-harian.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 6,
      "color": "from-emerald-400 to-teal-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "daily",
        "checklist",
        "reset",
        "shops",
        "routine"
      ],
      "relatedGuides": [
        "gold-early",
        "beginner-cooking"
      ]
    },
    "dog-care-fast-xp": {
      "id": "dog-care-fast-xp",
      "slug": "dog-care-fast-xp",
      "title": "Dog Care: cara naik level cepat (latihan + rutinitas)",
      "summary": "Dog Care biasanya lebih repot daripada Cat Care: latihan dan jalan-jalan jadi bagian dari paketnya. Rencanakan sesimu dan jangan kerjakan semuanya secara terpencar.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-indigo-400 to-blue-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "pets",
        "dog-care",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "cat-care-fast-xp"
      ]
    },
    "flowers": {
      "id": "flowers",
      "slug": "flower-crossbreeding",
      "title": "Persilangan bunga di Heartopia",
      "summary": "Cara kerja persilangan bunga di Heartopia — spesies, tingkat bintang, dan aturan penyiraman, plus info toko dan tips komunitas.",
      "category": "crafting",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-07-08",
      "readTimeMinutes": 7,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/guides/gardening-banner.webp",
      "tags": [
        "flowers",
        "crossbreeding",
        "gardening",
        "blanc"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "beginner-fishing",
        "gold-early"
      ]
    },
    "gardening-fast-xp": {
      "id": "gardening-fast-xp",
      "slug": "gardening-fast-xp",
      "title": "Gardening: naik level cepat dengan rotasi tanaman",
      "summary": "Tanaman cepat saat kamu online, tanaman lambat saat kamu pergi. XP datang dari irama — dan dari keragaman untuk koleksi.",
      "category": "crafting",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 4,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "tags": [
        "gardening",
        "hobby",
        "xp",
        "crops",
        "collection"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "level-up-gardening"
      ]
    },
    "gold-early": {
      "id": "gold-early",
      "slug": "gold-early",
      "title": "Panduan emas awal-permainan Heartopia (misi, fishing, memasak)",
      "summary": "Buat emas cepat awal Heartopia dengan rutinitas harian mudah: permintaan harian, fishing masak profit, dua rute pemula (jamur tiram + truffle hitam). Ada minimaps, setup kompor, FAQ.",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/generic-banner.webp",
      "tags": [
        "heartopia",
        "gold",
        "money",
        "beginner",
        "early game",
        "daily requests",
        "daily quests",
        "fishing",
        "cooking",
        "mushrooms",
        "oyster mushroom",
        "black truffle",
        "route",
        "map",
        "albert jr",
        "dg membership",
        "vip"
      ],
      "relatedGuides": [
        "daily-checklist",
        "beginner-cooking",
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "level-up-birdwatching": {
      "id": "level-up-birdwatching",
      "slug": "level-up-birdwatching",
      "title": "Naik level Birdwatching dengan cepat (tanpa penderitaan) di Heartopia",
      "summary": "Birdwatching adalah salah satu hobi paling lambat dinaikkan levelnya — sampai kamu menjalankan alur yang tepat: foto yang lebih baik, kemajuan koleksi, dan rotasi spesies.",
      "category": "exploration",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "Birdwatching",
        "Hobbies",
        "Leveling",
        "XP",
        "Collection",
        "Photos"
      ],
      "relatedGuides": [
        "beginner-birdwatching",
        "upgrade-hobbies"
      ]
    },
    "level-up-cooking": {
      "id": "level-up-cooking",
      "slug": "level-up-cooking",
      "title": "Cooking di Heartopia: cara tercepat naik level (XP)",
      "summary": "Menaikkan level Cooking soal volume + konsistensi: masak resep mudah secara borongan, buka varian untuk XP ekstra, dan rotasi resep agar tidak mentok bahan (termasuk batas pembelian harian). Rute praktis + daftar periksa.",
      "category": "cooking",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "bannerImage": "/guides/cooking-banner.webp",
      "hobby": "Cooking",
      "tags": [
        "cooking",
        "recipes",
        "xp",
        "leveling",
        "massimo"
      ],
      "relatedGuides": [
        "beginner-cooking",
        "cooking-fast-xp"
      ]
    },
    "level-up-fishing": {
      "id": "level-up-fishing",
      "slug": "level-up-fishing",
      "title": "Naik Level Memancing Cepat di Heartopia (rute + buff + checklist)",
      "summary": "Panduan Memancing praktis: rotasi spot, koleksi XP, dan setup mudah dengan Penarik Ikan Putri Laut + Minyak Wangi Putri Laut.",
      "category": "fishing",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "hobby": "Fishing",
      "tags": [
        "fishing",
        "hobbies",
        "leveling",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-fishing-fast-xp"
      ]
    },
    "level-up-gardening": {
      "id": "level-up-gardening",
      "slug": "level-up-gardening",
      "title": "Gardening di Heartopia: naik level tercepat (XP/jam)",
      "summary": "Menaikkan level Gardening soal siklus panen. Pilih tanaman berumur pendek saat kamu aktif (lebih banyak panen/jam) dan tanaman berumur panjang saat AFK. Ini rotasi praktisnya lengkap dengan booster dan daftar periksa.",
      "category": "crafting",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "bannerImage": "/guides/gardening-banner.webp",
      "hobby": "Gardening",
      "tags": [
        "gardening",
        "farming",
        "crops",
        "xp",
        "leveling"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "gardening-fast-xp"
      ]
    },
    "mlp-collab-guide": {
      "id": "mlp-collab-guide",
      "slug": "mlp-collab-guide",
      "title": "Heartopia x My Little Pony Panduan Acara",
      "summary": "Panduan lengkap Heartopia x My Little Pony collab: Rainbow Power sorta (mobil + paket lengkap), kumpulkan semua mobil hadiah, dan harian Harmony Tree Awakening dengan lencana cenderamata.",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-14",
      "readTimeMinutes": 8,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/events/mlp/mlp-banner.webp",
      "bannerImage": "/events/mlp/mlp-banner.webp",
      "tags": [
        "heartopia",
        "my little pony",
        "mlp",
        "event",
        "rainbow power",
        "gacha",
        "cars",
        "harmony tree",
        "souvenir badges"
      ],
      "relatedGuides": [
        "currencies",
        "daily-checklist",
        "gold-early"
      ]
    },
    "unlock-hobbies": {
      "id": "unlock-hobbies",
      "slug": "unlock-hobbies",
      "title": "Buka Hobi di Heartopia (Tiket, Mentor, Level D.G.)",
      "summary": "Cara buka setiap hobi di Heartopia: Tiket Perluasan Hobi, level D.G. (Developer), mentor, urutan buka, dan apa lakukan saat stuck menunggu tiket.",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-09",
      "readTimeMinutes": 6,
      "color": "from-violet-400 to-purple-500",
      "coverImage": "/guides/generic-banner.webp",
      "tags": [
        "guide",
        "beginner",
        "hobbies",
        "unlock",
        "hobby expansion ticket",
        "dg member",
        "developer level",
        "mentors"
      ],
      "relatedGuides": [
        "upgrade-hobbies",
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking"
      ]
    },
    "upgrade-hobbies": {
      "id": "upgrade-hobbies",
      "slug": "upgrade-hobbies",
      "title": "Tingkatkan Hobi di Heartopia (Meter, Tiket, Skill & Alat)",
      "summary": "Cara meningkatkan hobi di Heartopia: mengisi meter hobi, menggunakan Tiket Peningkat Hobi, sumber tiket, dan apa yang biasanya dibuka (skill, alat, kualitas lebih baik).",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-09",
      "readTimeMinutes": 6,
      "color": "from-indigo-400 to-violet-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "guide",
        "beginner",
        "hobbies",
        "upgrade",
        "hobby upgrade ticket",
        "skills",
        "tools",
        "meter",
        "dg member"
      ],
      "relatedGuides": [
        "unlock-hobbies",
        "beginner-birdwatching",
        "beginner-cooking",
        "gold-early"
      ]
    }
  },
  "th": {
    "animals": {
      "id": "animals",
      "slug": "animals",
      "title": "คู่มือสัตว์ป่า",
      "summary": "สัตว์ป่า: ตำแหน่งที่ป้อนอาหาร อาหารที่ชื่นชอบ โบนัสสภาพอากาศ รางวัลพันธะ และปลดล็อกเฟอร์นิเจอร์ธีมสัตว์",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-01-28",
      "readTimeMinutes": 6,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/animals-banner.webp",
      "bannerImage": "/guides/animals-banner.webp",
      "tags": [
        "animals",
        "wildlife",
        "beginner",
        "bonding"
      ],
      "relatedGuides": [
        "beginners-guide",
        "daily-checklist"
      ]
    },
    "beginner-birdwatching": {
      "id": "beginner-birdwatching",
      "slug": "birdwatching",
      "title": "สำรวจนกใน Heartopia: คู่มือผู้เริ่มต้น",
      "summary": "คู่มือผู้เริ่มต้น Birdwatching: ปลดล็อกกับ Bailey J. ใช้ Scanner เข้าใจการให้คะแนนดาว โดยการท่า หลีกเลี่ยงการ์ดไม่ถูกต้อง และรีไซเคิล Info Card (ขีดจำกัดรายวัน) เพื่อรางวัลและวัสดุ",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-01-28",
      "readTimeMinutes": 7,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "bannerImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "guide",
        "beginner",
        "hobby",
        "birdwatching",
        "scanner",
        "info-cards",
        "recycling",
        "nest-of-hundreds"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking"
      ]
    },
    "beginner-cooking": {
      "id": "beginner-cooking",
      "slug": "cooking-basics",
      "title": "การทำอาหารใน Heartopia: คู่มือผู้เริ่มต้น (ปลดล็อก สูตร)",
      "summary": "เรียน Cooking พื้นฐาน: ปลดล็อกกับ Massimo เชี่ยว minigame เตา ปลดล็อกสูตรมีประสิทธิภาพ ใช้จานมือใหม่เพื่อ XP & ทองคำเบื้องต้น",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "bannerImage": "/guides/cooking-banner.webp",
      "tags": [
        "guide",
        "cooking",
        "massimo",
        "recipes",
        "gold",
        "beginner",
        "hobby",
        "tickets"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "beginner-fishing-fast-xp": {
      "id": "beginner-fishing-fast-xp",
      "slug": "beginner-fishing-fast-xp",
      "title": "การตกปลาในเฮิร์ทโทเปีย: เก็บเลเวลให้ไวและเก็บคอลเลกชันให้ครบ",
      "summary": "เส้นทางสั้น ความคืบหน้าของคอลเลกชัน และชุดอุปกรณ์ง่าย ๆ (หางนางเงือก + ตัวล่อปลา) เพื่อเก็บ XP โดยไม่เสียเวลาไปกับการเดินทาง",
      "category": "fishing",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "tags": [
        "fishing",
        "hobby",
        "xp",
        "collection",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "level-up-fishing"
      ]
    },
    "beginner-fishing": {
      "id": "beginner-fishing",
      "slug": "how-to-fish",
      "title": "การตกปลาในเฮิร์ทโทเปีย: คู่มือมือใหม่ (การเล็ง แรงตึงสาย และเหยื่อ)",
      "summary": "เรียนรู้การตกปลาอย่างถูกวิธี: ปลดล็อกกับ Vanya ยังไง เล็งยังไง คุมแรงตึงสายยังไง ใช้เหยื่อยังไง และเก็บเลเวลให้ไวขึ้นยังไง",
      "category": "fishing",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-01-28",
      "readTimeMinutes": 7,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "hobby": "Fishing",
      "currency": "Gold",
      "tags": [
        "fishing",
        "hobby",
        "beginner",
        "bait",
        "vanya",
        "gold"
      ],
      "relatedGuides": [
        "unlock-hobbies",
        "upgrade-hobbies",
        "beginner-cooking"
      ]
    },
    "beginner-gardening": {
      "id": "beginner-gardening",
      "slug": "gardening",
      "title": "การทำสวนใน Heartopia: คู่มือผู้เริ่มต้น",
      "summary": "เรียน Gardening พื้นฐาน: ปลดล็อก Blanc วิธี Plant Boxes ผลกระทบการรดน้ำ กำจัดวัชพืช เมื่อ Fertilizer vs Growth Booster พืชเบื้องต้นหมุนเวียนง่าย มี FAQ & ลิงก์พืช สูตร ดอกไม้",
      "category": "crafting",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "bannerImage": "/guides/gardening-banner.webp",
      "tags": [
        "heartopia",
        "gardening",
        "crops",
        "blanc",
        "flowers",
        "fertilizer",
        "gold",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-cooking"
      ]
    },
    "beginner-insect-catching": {
      "id": "beginner-insect-catching",
      "slug": "insect-catching",
      "title": "การจับแมลงใน Heartopia: คู่มือมือใหม่",
      "summary": "เรียนรู้วิธีปลดล็อกการจับแมลง ใช้ Bubble Net อย่างถูกต้อง เพิ่มระดับได้เร็วขึ้น farm หายากด้วย Inflatable Insect Attractor และล้าง Bait the Insects อย่างมีประสิทธิภาพโดยไม่ใช้ stamina หมด",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-blue-400 to-sky-500",
      "coverImage": "/guides/insect-banner.webp",
      "bannerImage": "/guides/insect-banner.webp",
      "tags": [
        "heartopia",
        "insects",
        "insect-catching",
        "beginner",
        "event",
        "bait-the-insects"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "beginners-guide": {
      "id": "beginners-guide",
      "slug": "beginner-guide",
      "title": "คู่มือผู้เริ่มต้น Heartopia: เริ่มต้นเร็ว & งานอดิเรก",
      "summary": "คู่มือทั่วไปผู้เล่นใหม่: การสร้างตัวละคร ไม่กลัว reset รายวัน สกุลเงิน ทรัพยากร แผนที่ ความคืบหน้า D.G. ลำดับงานอดิเรก ลิงก์คู่มือเฉพาะ (Fishing Gardening Cooking Insects Birdwatching Animals Currencies Daily Checklist)",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 8,
      "color": "from-emerald-400 to-green-500",
      "coverImage": "/guides/generic-banner-3.webp",
      "tags": [
        "heartopia",
        "beginner",
        "guide",
        "daily",
        "currencies",
        "hobbies",
        "fishing",
        "gardening",
        "cooking",
        "insects",
        "birdwatching",
        "animals",
        "map"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking",
        "beginner-birdwatching",
        "beginner-insect-catching",
        "animals"
      ]
    },
    "birdwatching-fast-xp": {
      "id": "birdwatching-fast-xp",
      "slug": "birdwatching-fast-xp",
      "title": "ดูนก: วิธีเก็บเลเวลให้ไวขึ้น (และเลิกถ่ายรูปพัง)",
      "summary": "ฮอบบี้นี้ช้าอยู่แล้วโดยธรรมชาติ เคล็ดลับจึงเป็น เส้นทางสั้น + เน้นสายพันธุ์ใหม่ + ถ่ายให้นิ่งสม่ำเสมอ (Perfect Photo ช่วยได้เยอะ)",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "birdwatching",
        "hobby",
        "xp",
        "collection",
        "beginner"
      ],
      "relatedGuides": [
        "beginner-birdwatching",
        "level-up-birdwatching"
      ]
    },
    "cat-care-fast-xp": {
      "id": "cat-care-fast-xp",
      "slug": "cat-care-fast-xp",
      "title": "การดูแลแมว: วิธีเก็บเลเวลให้ไว (กิจวัตรประจำวัน + ของสะสม + เล่นร่วมกัน)",
      "summary": "การดูแลแมวคือประตูบานแรกของสัตว์เลี้ยง กิจวัตรเรียบง่าย ดูแลง่าย และดีมากสำหรับความคืบหน้ารายวันแบบสม่ำเสมอ",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "pets",
        "cat-care",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "dog-care-fast-xp"
      ]
    },
    "catch-insects-fast-xp": {
      "id": "catch-insects-fast-xp",
      "slug": "catch-insects-fast-xp",
      "title": "การจับแมลง: วิธีเก็บเลเวลให้ไวขึ้น",
      "summary": "การจับแมลงขึ้นอยู่กับฝีมือ ทำซ้ำอย่างมีแบบแผน + เน้นสายพันธุ์ใหม่ + ใช้ประโยชน์จากอีเวนต์และฝูงแมลงเมื่อมันโผล่มา",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-blue-400 to-sky-500",
      "coverImage": "/guides/insect-banner.webp",
      "tags": [
        "insects",
        "catch-insects",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "beginner-insect-catching"
      ]
    },
    "cooking-fast-xp": {
      "id": "cooking-fast-xp",
      "slug": "cooking-fast-xp",
      "title": "การทำอาหาร: วิธีเก็บเลเวลให้ไว (ทำทีละล็อต สูตรง่าย และเล่นร่วมกันอย่างฉลาด)",
      "summary": "การปั้นเลเวลทำอาหารคือการจัดคิว ทำหลายสูตรขนานกัน เลือกสูตรง่ายเพื่อทำซ้ำได้ และเน้นความหลากหลายเพื่อใบรับรองกับของสะสม",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "tags": [
        "cooking",
        "hobby",
        "xp",
        "recipes",
        "collection"
      ],
      "relatedGuides": [
        "beginner-cooking",
        "level-up-cooking"
      ]
    },
    "currencies": {
      "id": "currencies",
      "slug": "currencies",
      "title": "คู่มือสกุลเงิน",
      "summary": "เรียนรู้เกี่ยวกับสกุลเงินทั้งหมดใน Heartopia (ฟรี พรีเมียม และเฉพาะอีเวนต์เท่านั้น).",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-01-28",
      "readTimeMinutes": 6,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/generic-banner-3.webp",
      "relatedGuides": [
        "daily-checklist",
        "gold-early"
      ]
    },
    "daily-checklist": {
      "id": "daily-checklist",
      "slug": "daily-checklist",
      "title": "คู่มือตรวจสอบรายวัน",
      "summary": "รายการตรวจสอบรายวันที่ปฏิบัติได้โดยเน้นการรีเซ็ต ร้านค้ารายวัน และการกระทำที่มีขีดจำกัดรายวัน",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 6,
      "color": "from-emerald-400 to-teal-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "daily",
        "checklist",
        "reset",
        "shops",
        "routine"
      ],
      "relatedGuides": [
        "gold-early",
        "beginner-cooking"
      ]
    },
    "dog-care-fast-xp": {
      "id": "dog-care-fast-xp",
      "slug": "dog-care-fast-xp",
      "title": "การดูแลสุนัข: วิธีเก็บเลเวลให้ไว (ฝึก + กิจวัตร)",
      "summary": "การดูแลสุนัขมักจะจุกจิกกว่าการดูแลแมว เพราะการฝึกและการพาเดินเล่นเป็นส่วนหนึ่งของงาน วางแผนรอบเล่นของคุณไว้ อย่าทำกระจัดกระจาย",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 5,
      "color": "from-indigo-400 to-blue-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "pets",
        "dog-care",
        "hobby",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "cat-care-fast-xp"
      ]
    },
    "flowers": {
      "id": "flowers",
      "slug": "flower-crossbreeding",
      "title": "การผสมข้ามพันธุ์ดอกไม้ในเฮิร์ทโทเปีย",
      "summary": "การผสมข้ามพันธุ์ดอกไม้ในเฮิร์ทโทเปียทำงานอย่างไร — สายพันธุ์ ระดับดาว และกติกาการรดน้ำ พร้อมข้อมูลร้านค้าและเคล็ดลับจากคอมมูนิตี้",
      "category": "crafting",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-07-08",
      "readTimeMinutes": 7,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/guides/gardening-banner.webp",
      "tags": [
        "flowers",
        "crossbreeding",
        "gardening",
        "blanc"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "beginner-fishing",
        "gold-early"
      ]
    },
    "gardening-fast-xp": {
      "id": "gardening-fast-xp",
      "slug": "gardening-fast-xp",
      "title": "การทำสวน: เก็บเลเวลให้ไวด้วยการหมุนเวียนพืชผล",
      "summary": "ปลูกพืชโตไวตอนออนไลน์ ปลูกพืชโตช้าตอนไม่อยู่ XP มาจากจังหวะ และมาจากความหลากหลายเพื่อของสะสม",
      "category": "crafting",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 4,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "tags": [
        "gardening",
        "hobby",
        "xp",
        "crops",
        "collection"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "level-up-gardening"
      ]
    },
    "gold-early": {
      "id": "gold-early",
      "slug": "gold-early",
      "title": "คู่มือทองคำเบื้องต้น Heartopia (ภารกิจ ตกปลา ทำอาหาร)",
      "summary": "ทำทองคำเร็วเบื้องต้น Heartopia: ประจำวันง่าย ภารกิจรายวัน ตกปลาทำอาหารกำไร 2 เส้นทางมือใหม่ (เห็ด ทรัฟเฟิล) minimaps setup เตา FAQ",
      "category": "cooking",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-03",
      "readTimeMinutes": 7,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/generic-banner.webp",
      "tags": [
        "heartopia",
        "gold",
        "money",
        "beginner",
        "early game",
        "daily requests",
        "daily quests",
        "fishing",
        "cooking",
        "mushrooms",
        "oyster mushroom",
        "black truffle",
        "route",
        "map",
        "albert jr",
        "dg membership",
        "vip"
      ],
      "relatedGuides": [
        "daily-checklist",
        "beginner-cooking",
        "beginner-fishing",
        "beginner-gardening"
      ]
    },
    "level-up-birdwatching": {
      "id": "level-up-birdwatching",
      "slug": "level-up-birdwatching",
      "title": "เก็บเลเวล Birdwatching ให้ไว (แบบไม่ทรมาน) ในเฮิร์ทโทเปีย",
      "summary": "Birdwatching เป็นหนึ่งในงานอดิเรกที่เก็บเลเวลช้าที่สุด จนกว่าคุณจะเดินวงจรที่ถูกต้อง: ถ่ายรูปให้ดีขึ้น เก็บคอลเลกชันให้คืบหน้า และหมุนเวียนสายพันธุ์",
      "category": "exploration",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-sky-400 to-blue-500",
      "coverImage": "/guides/birdwatching-guide.webp",
      "tags": [
        "Birdwatching",
        "Hobbies",
        "Leveling",
        "XP",
        "Collection",
        "Photos"
      ],
      "relatedGuides": [
        "beginner-birdwatching",
        "upgrade-hobbies"
      ]
    },
    "level-up-cooking": {
      "id": "level-up-cooking",
      "slug": "level-up-cooking",
      "title": "Cooking ในเฮิร์ทโทเปีย: วิธีเก็บเลเวล (XP) ให้เร็วที่สุด",
      "summary": "การเก็บเลเวล Cooking คือปริมาณบวกความสม่ำเสมอ: ทำสูตรง่าย ๆ ทีละล็อต ปลดล็อกสูตรย่อยเพื่อรับ XP เพิ่ม และหมุนเวียนสูตรเพื่อเลี่ยงการติดขัดเรื่องวัตถุดิบ (รวมถึงเพดานการซื้อรายวัน) พร้อมเส้นทางที่ใช้ได้จริงและเช็กลิสต์",
      "category": "cooking",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-amber-400 to-orange-500",
      "coverImage": "/guides/cooking-banner.webp",
      "bannerImage": "/guides/cooking-banner.webp",
      "hobby": "Cooking",
      "tags": [
        "cooking",
        "recipes",
        "xp",
        "leveling",
        "massimo"
      ],
      "relatedGuides": [
        "beginner-cooking",
        "cooking-fast-xp"
      ]
    },
    "level-up-fishing": {
      "id": "level-up-fishing",
      "slug": "level-up-fishing",
      "title": "เพิ่มระดับการตกปลาอย่างรวดเร็วใน Heartopia (เส้นทาง + Buff + รายการตรวจสอบ)",
      "summary": "คู่มือการตกปลาเชิงปฏิบัติ: การหมุนเวียนจุด การรวบรวม XP และการตั้งค่าง่ายๆ ด้วย Mermaid Fish Attractor + Mermaid Perfume.",
      "category": "fishing",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-cyan-400 to-blue-500",
      "coverImage": "/guides/fishing-banner.webp",
      "bannerImage": "/guides/fishing-banner.webp",
      "hobby": "Fishing",
      "tags": [
        "fishing",
        "hobbies",
        "leveling",
        "xp",
        "collection"
      ],
      "relatedGuides": [
        "beginner-fishing",
        "beginner-fishing-fast-xp"
      ]
    },
    "level-up-gardening": {
      "id": "level-up-gardening",
      "slug": "level-up-gardening",
      "title": "Gardening ในเฮิร์ทโทเปีย: เก็บเลเวลให้เร็วที่สุด (XP ต่อชั่วโมง)",
      "summary": "การเก็บเลเวล Gardening อยู่ที่รอบการเก็บเกี่ยว เลือกพืชโตไวตอนเล่นอยู่ (เก็บเกี่ยวได้บ่อยกว่าต่อชั่วโมง) และพืชโตช้าตอน AFK นี่คือแผนหมุนเวียนที่ใช้ได้จริง พร้อมไอเทมเร่งและเช็กลิสต์",
      "category": "crafting",
      "difficulty": "medium",
      "author": "Heartopia.guide",
      "date": "2026-02-10",
      "readTimeMinutes": 6,
      "color": "from-green-400 to-emerald-500",
      "coverImage": "/guides/gardening-banner.webp",
      "bannerImage": "/guides/gardening-banner.webp",
      "hobby": "Gardening",
      "tags": [
        "gardening",
        "farming",
        "crops",
        "xp",
        "leveling"
      ],
      "relatedGuides": [
        "beginner-gardening",
        "gardening-fast-xp"
      ]
    },
    "mlp-collab-guide": {
      "id": "mlp-collab-guide",
      "slug": "mlp-collab-guide",
      "title": "Heartopia x My Little Pony คู่มือเหตุการณ์",
      "summary": "คู่มือฉบับเต็ม Heartopia x My Little Pony collab: Rainbow Power gacha (รถ + ชุดเต็ม) เก็บรถรางวัลทั้งหมด & Harmony Tree Awakening รายวัน + เหรียญที่ระลึก",
      "category": "exploration",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-14",
      "readTimeMinutes": 8,
      "color": "from-pink-400 to-rose-500",
      "coverImage": "/events/mlp/mlp-banner.webp",
      "bannerImage": "/events/mlp/mlp-banner.webp",
      "tags": [
        "heartopia",
        "my little pony",
        "mlp",
        "event",
        "rainbow power",
        "gacha",
        "cars",
        "harmony tree",
        "souvenir badges"
      ],
      "relatedGuides": [
        "currencies",
        "daily-checklist",
        "gold-early"
      ]
    },
    "unlock-hobbies": {
      "id": "unlock-hobbies",
      "slug": "unlock-hobbies",
      "title": "ปลดล็อกงานอดิเรกใน Heartopia (ตั๋ว อาจารย์ ระดับ D.G.)",
      "summary": "วิธีปลดล็อกงานอดิเรกทุกอย่างใน Heartopia: ตั๋วเสริมงานอดิเรก ระดับ D.G. (Developer) อาจารย์ ลำดับการปลดล็อก และควรทำอะไรเมื่อติดขัดรอตั๋ว",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-09",
      "readTimeMinutes": 6,
      "color": "from-violet-400 to-purple-500",
      "coverImage": "/guides/generic-banner.webp",
      "tags": [
        "guide",
        "beginner",
        "hobbies",
        "unlock",
        "hobby expansion ticket",
        "dg member",
        "developer level",
        "mentors"
      ],
      "relatedGuides": [
        "upgrade-hobbies",
        "beginner-fishing",
        "beginner-gardening",
        "beginner-cooking"
      ]
    },
    "upgrade-hobbies": {
      "id": "upgrade-hobbies",
      "slug": "upgrade-hobbies",
      "title": "อัปเกรดงานอดิเรกใน Heartopia (เกจ ตั๋ว ทักษะ และเครื่องมือ)",
      "summary": "วิธีอัปเกรดงานอดิเรกใน Heartopia: เติมเกจงานอดิเรก ใช้ตั๋วอัปเกรดงานอดิเรก แหล่งที่มาของตั๋ว และสิ่งที่อัปเกรดมักจะปลดล็อก (ทักษะ เครื่องมือ คุณภาพดีขึ้น).",
      "category": "beginner",
      "difficulty": "easy",
      "author": "Heartopia.guide",
      "date": "2026-02-09",
      "readTimeMinutes": 6,
      "color": "from-indigo-400 to-violet-500",
      "coverImage": "/guides/generic-banner-2.webp",
      "tags": [
        "guide",
        "beginner",
        "hobbies",
        "upgrade",
        "hobby upgrade ticket",
        "skills",
        "tools",
        "meter",
        "dg member"
      ],
      "relatedGuides": [
        "unlock-hobbies",
        "beginner-birdwatching",
        "beginner-cooking",
        "gold-early"
      ]
    }
  }
};
